// Conversation Detail page translations
export const conversationDetailTranslations = {
  en: {
    "title": "Interview Conversation Record",
    "interviewee": "Interviewee",
    "anonymous": "Anonymous",
    "interviewInfo": "Interview Information",
    "conversationContent": "Conversation Content",
    "conversationStatistics": "Conversation Statistics",
    "noConversationData": "No conversation data available",
    "backToAnalytics": "Back to Analytics",
    "previousInterview": "Previous interview",
    "nextInterview": "Next interview",
    "likeInterview": "Mark as a good interview",
    "unlikeInterview": "Unmark as a good interview",
    "noPreviousInterview": "No previous interview",
    "noNextInterview": "No next interview",
    "confirmComplete": "Are you sure you want to mark this interview as completed?",
    "confirmDelete": "Are you sure you want to delete this interview? This action cannot be undone.",
    "actions": {
      "complete": "Mark as Completed",
      "delete": "Delete"
    },
    "labels": {
      "age": "Age",
      "gender": "Gender",
      "occupation": "Occupation",
      "education": "Education",
      "duration": "Duration",
      "status": "Status",
      "totalMessages": "Total Messages",
      "userMessages": "User Messages",
      "aiMessages": "AI Messages",
      "avgUserLength": "Average User Message Length",
      "avgAiLength": "Average AI Message Length"
    },
    "roles": {
      "interviewee": "Interviewee",
      "aiInterviewer": "AI Interviewer"
    },
    "customForm": {
      "title": "Custom form information",
      "field": "Field",
      "na": "N/A"
    },
    "status": {
      "completed": "Completed",
      "inProgress": "In Progress"
    },
    "minutes": "minutes",
    "qualityAssessment": {
      "title": "Quality Assessment & Key Takeaway",
      "coreTakeaway": "Core Takeaway",
      "excellent": "Excellent",
      "good": "Good",
      "fair": "Fair",
      "poor": "Poor",
      "tooShort": "Interview Too Short",
      "unknown": "Unknown"
    },
    "methodology": {
      "title": "Data Collection Methodology",
      "subtitle": "For citation purposes",
      "collectionDate": "Data collection date",
      "interviewType": "Interview type",
      "structured": "Structured",
      "semiStructured": "Semi-structured",
      "responderModel": "Response model",
      "supervisorModel": "Supervision model",
      "temperature": "Temperature",
      "topP": "Top-p",
      "topK": "Top-k",
      "transcriptionEngine": "Transcription engine",
      "noSupervisor": "N/A (structured interview)",
      "notApplicable": "Not applicable",
      "copyCitation": "Copy citation text",
      "copied": "Copied!",
      "citationTemplate": "Interviews were conducted on {{date}} using the Qualitati platform (qualitati.com). AI responses were generated by {{responderModel}} ({{responderProvider}}) with a temperature of {{temperature}}, top-p of {{topP}}, and top-k of {{topK}}. {{supervisorText}}Speech transcription used {{transcriptionEngine}}.",
      "citationSupervisorText": "A supervision layer ({{supervisorModel}}, temperature {{supervisorTemp}}) guided the interview flow. ",
 "interviewMode": "Interview mode",
 "modeSingle": "Single model",
 "modeDual": "Dual model (with supervisor)",
 "companyPairing": "Company pairing",
 "pairingSame": "Same company",
 "pairingDifferent": "Different companies",
 "pairingNA": "N/A",
 "pairingUnknown": "Unknown",
 "participantRating": "Participant rating",
    }
  },
  zh: {
    "title": "访谈对话记录",
    "interviewee": "受访者",
    "anonymous": "匿名",
    "interviewInfo": "访谈信息",
    "conversationContent": "对话内容",
    "conversationStatistics": "对话统计",
    "noConversationData": "暂无对话记录",
    "backToAnalytics": "返回分析页面",
    "previousInterview": "上一个访谈",
    "nextInterview": "下一个访谈",
    "likeInterview": "标记为好访谈",
    "unlikeInterview": "取消标记好访谈",
    "noPreviousInterview": "没有上一个访谈",
    "noNextInterview": "没有下一个访谈",
    "confirmComplete": "确定要将此访谈标记为已完成吗？",
    "confirmDelete": "确定要删除此访谈吗？此操作无法撤销。",
    "actions": {
      "complete": "标记为已完成",
      "delete": "删除"
    },
    "labels": {
      "age": "年龄",
      "gender": "性别",
      "occupation": "职业",
      "education": "教育",
      "duration": "时长",
      "status": "状态",
      "totalMessages": "总消息数",
      "userMessages": "用户消息",
      "aiMessages": "AI消息",
      "avgUserLength": "平均用户消息长度",
      "avgAiLength": "平均AI消息长度"
    },
    "roles": {
      "interviewee": "受访者",
      "aiInterviewer": "AI访谈员"
    },
    "customForm": {
      "title": "自定义表单信息",
      "field": "字段",
      "na": "无"
    },
    "status": {
      "completed": "已完成",
      "inProgress": "进行中"
    },
    "minutes": "分钟",
    "qualityAssessment": {
      "title": "质量评估与核心要点",
      "coreTakeaway": "核心要点",
      "excellent": "优秀",
      "good": "良好",
      "fair": "一般",
      "poor": "较差",
      "tooShort": "访谈过短",
      "unknown": "未知"
    },
    "methodology": {
      "title": "数据收集方法论",
      "subtitle": "供学术引用",
      "collectionDate": "数据收集日期",
      "interviewType": "访谈类型",
      "structured": "结构化",
      "semiStructured": "半结构化",
      "responderModel": "回复模型",
      "supervisorModel": "监督模型",
      "temperature": "温度",
      "topP": "Top-p",
      "topK": "Top-k",
      "transcriptionEngine": "转录引擎",
      "noSupervisor": "无（结构化访谈）",
      "notApplicable": "不适用",
      "copyCitation": "复制引用文本",
      "copied": "已复制！",
      "citationTemplate": "访谈于{{date}}通过Qualitati平台（qualitati.com）进行。AI回复由{{responderModel}}（{{responderProvider}}）生成，温度参数为{{temperature}}，Top-p为{{topP}}，Top-k为{{topK}}。{{supervisorText}}语音转录使用{{transcriptionEngine}}。",
      "citationSupervisorText": "监督层（{{supervisorModel}}，温度{{supervisorTemp}}）引导了访谈流程。",
 "interviewMode": "访谈模式",
 "modeSingle": "单模型",
 "modeDual": "双模型（含监督）",
 "companyPairing": "公司组合",
 "pairingSame": "同一公司",
 "pairingDifferent": "不同公司",
 "pairingNA": "不适用",
 "pairingUnknown": "未知",
 "participantRating": "参与者评分",
    }
  },
  fr: {
    "title": "Enregistrement de Conversation d'Entretien",
    "interviewee": "Personne Interviewée",
    "anonymous": "Anonyme",
    "interviewInfo": "Informations d'Entretien",
    "conversationContent": "Contenu de la Conversation",
    "conversationStatistics": "Statistiques de Conversation",
    "noConversationData": "Aucune donnée de conversation disponible",
    "backToAnalytics": "Retour aux Analyses",
    "previousInterview": "Entretien précédent",
    "nextInterview": "Entretien suivant",
    "likeInterview": "Marquer comme un bon entretien",
    "unlikeInterview": "Retirer le marquage de bon entretien",
    "noPreviousInterview": "Aucun entretien précédent",
    "noNextInterview": "Aucun entretien suivant",
    "confirmComplete": "Êtes-vous sûr de vouloir marquer cet entretien comme terminé ?",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer cet entretien ? Cette action ne peut pas être annulée.",
    "actions": {
      "complete": "Marquer comme terminé",
      "delete": "Supprimer"
    },
    "labels": {
      "age": "Âge",
      "gender": "Sexe",
      "occupation": "Profession",
      "education": "Éducation",
      "duration": "Durée",
      "status": "Statut",
      "totalMessages": "Total des Messages",
      "userMessages": "Messages Utilisateur",
      "aiMessages": "Messages IA",
      "avgUserLength": "Longueur Moyenne des Messages Utilisateur",
      "avgAiLength": "Longueur Moyenne des Messages IA"
    },
    "roles": {
      "interviewee": "Personne Interviewée",
      "aiInterviewer": "Intervieweur IA"
    },
    "customForm": {
      "title": "Informations du formulaire personnalisé",
      "field": "Champ",
      "na": "N/D"
    },
    "status": {
      "completed": "Terminé",
      "inProgress": "En Cours"
    },
    "minutes": "minutes",
    "qualityAssessment": {
      "title": "Évaluation de la Qualité et Point Clé",
      "coreTakeaway": "Point Clé Principal",
      "excellent": "Excellent",
      "good": "Bon",
      "fair": "Moyen",
      "poor": "Faible",
      "tooShort": "Entretien Trop Court",
      "unknown": "Inconnu"
    },
    "methodology": {
      "title": "Méthodologie de collecte de données",
      "subtitle": "À des fins de citation",
      "collectionDate": "Date de collecte des données",
      "interviewType": "Type d'entretien",
      "structured": "Structuré",
      "semiStructured": "Semi-structuré",
      "responderModel": "Modèle de réponse",
      "supervisorModel": "Modèle de supervision",
      "temperature": "Température",
      "topP": "Top-p",
      "topK": "Top-k",
      "transcriptionEngine": "Moteur de transcription",
      "noSupervisor": "N/A (entretien structuré)",
      "notApplicable": "Non applicable",
      "copyCitation": "Copier le texte de citation",
      "copied": "Copié !",
      "citationTemplate": "Les entretiens ont été conduits le {{date}} via la plateforme Qualitati (qualitati.com). Les réponses de l'IA ont été générées par {{responderModel}} ({{responderProvider}}) avec une température de {{temperature}}, un top-p de {{topP}} et un top-k de {{topK}}. {{supervisorText}}La transcription vocale a utilisé {{transcriptionEngine}}.",
      "citationSupervisorText": "Une couche de supervision ({{supervisorModel}}, température {{supervisorTemp}}) a guidé le déroulement de l'entretien. ",
 "interviewMode": "Mode d'entretien",
 "modeSingle": "Modèle unique",
 "modeDual": "Modèle double (avec superviseur)",
 "companyPairing": "Combinaison d'entreprises",
 "pairingSame": "Même entreprise",
 "pairingDifferent": "Entreprises différentes",
 "pairingNA": "N/A",
 "pairingUnknown": "Inconnu",
 "participantRating": "Évaluation du participant",
    }
  },
  nb: {
    "title": "Intervju Samtaleopptak",
    "interviewee": "Intervjudeltaker",
    "anonymous": "Anonym",
    "interviewInfo": "Intervjuinformasjon",
    "conversationContent": "Samtaleinnhold",
    "conversationStatistics": "Samtalestatistikk",
    "noConversationData": "Ingen samtaledata tilgjengelig",
    "backToAnalytics": "Tilbake til Analyse",
    "previousInterview": "Forrige intervju",
    "nextInterview": "Neste intervju",
    "likeInterview": "Merk som et godt intervju",
    "unlikeInterview": "Fjern merket som godt intervju",
    "noPreviousInterview": "Ingen forrige intervju",
    "noNextInterview": "Ingen neste intervju",
    "confirmComplete": "Er du sikker på at du vil merke dette intervjuet som fullført?",
    "confirmDelete": "Er du sikker på at du vil slette dette intervjuet? Denne handlingen kan ikke angres.",
    "actions": {
      "complete": "Merk som fullført",
      "delete": "Slett"
    },
    "labels": {
      "age": "Alder",
      "gender": "Kjønn",
      "occupation": "Yrke",
      "education": "Utdanning",
      "duration": "Varighet",
      "status": "Status",
      "totalMessages": "Totale Meldinger",
      "userMessages": "Brukermeldinger",
      "aiMessages": "AI Meldinger",
      "avgUserLength": "Gjennomsnittlig Brukermelding Lengde",
      "avgAiLength": "Gjennomsnittlig AI Melding Lengde"
    },
    "roles": {
      "interviewee": "Intervjudeltaker",
      "aiInterviewer": "AI Intervjuer"
    },
    "customForm": {
      "title": "Egendefinert skjemainformasjon",
      "field": "Felt",
      "na": "Ikke oppgitt"
    },
    "status": {
      "completed": "Fullført",
      "inProgress": "Pågår"
    },
    "minutes": "minutter",
    "qualityAssessment": {
      "title": "Kvalitetsvurdering og Hovedpoeng",
      "coreTakeaway": "Hovedpoeng",
      "excellent": "Utmerket",
      "good": "Bra",
      "fair": "Gjennomsnittlig",
      "poor": "Dårlig",
      "tooShort": "Intervju for kort",
      "unknown": "Ukjent"
    },
    "methodology": {
      "title": "Metode for datainnsamling",
      "subtitle": "For siteringsformål",
      "collectionDate": "Dato for datainnsamling",
      "interviewType": "Intervjutype",
      "structured": "Strukturert",
      "semiStructured": "Semi-strukturert",
      "responderModel": "Responsmodell",
      "supervisorModel": "Superviseringsmodell",
      "temperature": "Temperatur",
      "topP": "Top-p",
      "topK": "Top-k",
      "transcriptionEngine": "Transkripsjonsmotor",
      "noSupervisor": "Ikke aktuelt (strukturert intervju)",
      "notApplicable": "Ikke aktuelt",
      "copyCitation": "Kopier siteringstekst",
      "copied": "Kopiert!",
      "citationTemplate": "Intervjuene ble gjennomført {{date}} via Qualitati-plattformen (qualitati.com). AI-svar ble generert av {{responderModel}} ({{responderProvider}}) med en temperatur på {{temperature}}, top-p på {{topP}} og top-k på {{topK}}. {{supervisorText}}Taletranskripsjonen brukte {{transcriptionEngine}}.",
      "citationSupervisorText": "Et supervisjonslag ({{supervisorModel}}, temperatur {{supervisorTemp}}) styrte intervjuforløpet. ",
 "interviewMode": "Intervjumodus",
 "modeSingle": "Enkel modell",
 "modeDual": "Dobbel modell (med veileder)",
 "companyPairing": "Selskapskombinasjon",
 "pairingSame": "Samme selskap",
 "pairingDifferent": "Forskjellige selskaper",
 "pairingNA": "Ikke aktuelt",
 "pairingUnknown": "Ukjent",
 "participantRating": "Deltakers vurdering",
    }
  },
  nl: {
    "title": "Interview Gespreksopname",
    "interviewee": "Geïnterviewde",
    "anonymous": "Anoniem",
    "interviewInfo": "Interview Informatie",
    "conversationContent": "Gespreksinhoud",
    "conversationStatistics": "Gespreksstatistieken",
    "noConversationData": "Geen gespreksgegevens beschikbaar",
    "backToAnalytics": "Terug naar Analyse",
    "previousInterview": "Vorig interview",
    "nextInterview": "Volgend interview",
    "likeInterview": "Markeer als een goed interview",
    "unlikeInterview": "Markering als goed interview verwijderen",
    "noPreviousInterview": "Geen vorig interview",
    "noNextInterview": "Geen volgend interview",
    "confirmComplete": "Weet u zeker dat u dit interview als voltooid wilt markeren?",
    "confirmDelete": "Weet u zeker dat u dit interview wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
    "actions": {
      "complete": "Markeren als voltooid",
      "delete": "Verwijderen"
    },
    "labels": {
      "age": "Leeftijd",
      "gender": "Geslacht",
      "occupation": "Beroep",
      "education": "Onderwijs",
      "duration": "Duur",
      "status": "Status",
      "totalMessages": "Totaal Berichten",
      "userMessages": "Gebruikersberichten",
      "aiMessages": "AI Berichten",
      "avgUserLength": "Gemiddelde Gebruikersbericht Lengte",
      "avgAiLength": "Gemiddelde AI Bericht Lengte"
    },
    "roles": {
      "interviewee": "Geïnterviewde",
      "aiInterviewer": "AI Interviewer"
    },
    "customForm": {
      "title": "Aangepaste formulierinformatie",
      "field": "Veld",
      "na": "N.v.t."
    },
    "status": {
      "completed": "Voltooid",
      "inProgress": "Bezig"
    },
    "minutes": "minuten",
    "qualityAssessment": {
      "title": "Kwaliteitsbeoordeling en Kernpunt",
      "coreTakeaway": "Kernpunt",
      "excellent": "Uitstekend",
      "good": "Goed",
      "fair": "Redelijk",
      "poor": "Slecht",
      "tooShort": "Interview te kort",
      "unknown": "Onbekend"
    },
    "methodology": {
      "title": "Methodologie voor gegevensverzameling",
      "subtitle": "Voor citatiedoeleinden",
      "collectionDate": "Datum gegevensverzameling",
      "interviewType": "Type interview",
      "structured": "Gestructureerd",
      "semiStructured": "Semi-gestructureerd",
      "responderModel": "Antwoordmodel",
      "supervisorModel": "Supervisiemodel",
      "temperature": "Temperatuur",
      "topP": "Top-p",
      "topK": "Top-k",
      "transcriptionEngine": "Transcriptie-engine",
      "noSupervisor": "N.v.t. (gestructureerd interview)",
      "notApplicable": "Niet van toepassing",
      "copyCitation": "Citatietekst kopiëren",
      "copied": "Gekopieerd!",
      "citationTemplate": "Interviews werden afgenomen op {{date}} via het Qualitati-platform (qualitati.com). AI-antwoorden werden gegenereerd door {{responderModel}} ({{responderProvider}}) met een temperatuur van {{temperature}}, top-p van {{topP}} en top-k van {{topK}}. {{supervisorText}}Spraaktranscriptie gebruikte {{transcriptionEngine}}.",
      "citationSupervisorText": "Een supervisielaag ({{supervisorModel}}, temperatuur {{supervisorTemp}}) begeleidde het interviewverloop. ",
 "interviewMode": "Interviewmodus",
 "modeSingle": "Eén model",
 "modeDual": "Twee modellen (met supervisor)",
 "companyPairing": "Bedrijfscombinatie",
 "pairingSame": "Zelfde bedrijf",
 "pairingDifferent": "Verschillende bedrijven",
 "pairingNA": "N.v.t.",
 "pairingUnknown": "Onbekend",
 "participantRating": "Beoordeling van deelnemer",
    }
  },
  de: {
    "title": "Interview-Gesprächsprotokoll",
    "interviewee": "Interviewpartner",
    "anonymous": "Anonym",
    "interviewInfo": "Interview-Informationen",
    "conversationContent": "Gesprächsinhalt",
    "conversationStatistics": "Gesprächsstatistiken",
    "noConversationData": "Keine Gesprächsdaten verfügbar",
    "backToAnalytics": "Zurück zur Analyse",
    "previousInterview": "Vorheriges Interview",
    "nextInterview": "Nächstes Interview",
    "likeInterview": "Als gutes Interview markieren",
    "unlikeInterview": "Markierung als gutes Interview entfernen",
    "noPreviousInterview": "Kein vorheriges Interview",
    "noNextInterview": "Kein nächstes Interview",
    "confirmComplete": "Sind Sie sicher, dass Sie dieses Interview als abgeschlossen markieren möchten?",
    "confirmDelete": "Sind Sie sicher, dass Sie dieses Interview löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "actions": {
      "complete": "Als abgeschlossen markieren",
      "delete": "Löschen"
    },
    "labels": {
      "age": "Alter",
      "gender": "Geschlecht",
      "occupation": "Beruf",
      "education": "Bildung",
      "duration": "Dauer",
      "status": "Status",
      "totalMessages": "Nachrichten Gesamt",
      "userMessages": "Benutzernachrichten",
      "aiMessages": "KI-Nachrichten",
      "avgUserLength": "Durchschnittliche Länge der Benutzernachrichten",
      "avgAiLength": "Durchschnittliche Länge der KI-Nachrichten"
    },
    "roles": {
      "interviewee": "Interviewpartner",
      "aiInterviewer": "KI-Interviewer"
    },
    "customForm": {
      "title": "Benutzerdefinierte Formulardaten",
      "field": "Feld",
      "na": "k.A."
    },
    "status": {
      "completed": "Abgeschlossen",
      "inProgress": "In Bearbeitung"
    },
    "minutes": "Minuten",
    "qualityAssessment": {
      "title": "Qualitätsbewertung & Kernpunkt",
      "coreTakeaway": "Kernpunkt",
      "excellent": "Ausgezeichnet",
      "good": "Gut",
      "fair": "Ausreichend",
      "poor": "Schlecht",
      "tooShort": "Interview zu kurz",
      "unknown": "Unbekannt"
    },
    "methodology": {
      "title": "Methodik der Datenerhebung",
      "subtitle": "Für Zitationszwecke",
      "collectionDate": "Datum der Datenerhebung",
      "interviewType": "Interviewtyp",
      "structured": "Strukturiert",
      "semiStructured": "Halbstrukturiert",
      "responderModel": "Antwortmodell",
      "supervisorModel": "Supervisionsmodell",
      "temperature": "Temperatur",
      "topP": "Top-p",
      "topK": "Top-k",
      "transcriptionEngine": "Transkriptionsmodul",
      "noSupervisor": "Nicht zutreffend (strukturiertes Interview)",
      "notApplicable": "Nicht zutreffend",
      "copyCitation": "Zitationstext kopieren",
      "copied": "Kopiert!",
      "citationTemplate": "Interviews wurden am {{date}} über die Qualitati-Plattform (qualitati.com) durchgeführt. KI-Antworten wurden von {{responderModel}} ({{responderProvider}}) mit einer Temperatur von {{temperature}}, Top-p von {{topP}} und Top-k von {{topK}} generiert. {{supervisorText}}Die Sprachtranskription verwendete {{transcriptionEngine}}.",
      "citationSupervisorText": "Eine Supervisionsebene ({{supervisorModel}}, Temperatur {{supervisorTemp}}) leitete den Interviewverlauf. ",
 "interviewMode": "Interview-Modus",
 "modeSingle": "Einzelmodell",
 "modeDual": "Doppelmodell (mit Supervisor)",
 "companyPairing": "Unternehmenspaarung",
 "pairingSame": "Gleiches Unternehmen",
 "pairingDifferent": "Verschiedene Unternehmen",
 "pairingNA": "N/V",
 "pairingUnknown": "Unbekannt",
 "participantRating": "Teilnehmerbewertung",
    }
  },
  es: {
    "title": "Registro de Conversación de Entrevista",
    "interviewee": "Entrevistado",
    "anonymous": "Anónimo",
    "interviewInfo": "Información de la Entrevista",
    "conversationContent": "Contenido de la Conversación",
    "conversationStatistics": "Estadísticas de la Conversación",
    "noConversationData": "No hay datos de conversación disponibles",
    "backToAnalytics": "Volver a Análisis",
    "previousInterview": "Entrevista anterior",
    "nextInterview": "Siguiente entrevista",
    "likeInterview": "Marcar como una buena entrevista",
    "unlikeInterview": "Quitar marca de buena entrevista",
    "noPreviousInterview": "No hay entrevista anterior",
    "noNextInterview": "No hay entrevista siguiente",
    "confirmComplete": "¿Está seguro de que desea marcar esta entrevista como completada?",
    "confirmDelete": "¿Está seguro de que desea eliminar esta entrevista? Esta acción no se puede deshacer.",
    "actions": {
      "complete": "Marcar como completado",
      "delete": "Eliminar"
    },
    "labels": {
      "age": "Edad",
      "gender": "Género",
      "occupation": "Ocupación",
      "education": "Educación",
      "duration": "Duración",
      "status": "Estado",
      "totalMessages": "Total de Mensajes",
      "userMessages": "Mensajes del Usuario",
      "aiMessages": "Mensajes de IA",
      "avgUserLength": "Longitud Promedio de Mensajes del Usuario",
      "avgAiLength": "Longitud Promedio de Mensajes de IA"
    },
    "roles": {
      "interviewee": "Entrevistado",
      "aiInterviewer": "Entrevistador IA"
    },
    "customForm": {
      "title": "Información del formulario personalizado",
      "field": "Campo",
      "na": "N/D"
    },
    "status": {
      "completed": "Completado",
      "inProgress": "En Progreso"
    },
    "minutes": "minutos",
    "qualityAssessment": {
      "title": "Evaluación de Calidad y Conclusión Clave",
      "coreTakeaway": "Conclusión Principal",
      "excellent": "Excelente",
      "good": "Bueno",
      "fair": "Regular",
      "poor": "Pobre",
      "tooShort": "Entrevista Demasiado Corta",
      "unknown": "Desconocido"
    },
    "methodology": {
      "title": "Metodología de recopilación de datos",
      "subtitle": "Con fines de citación",
      "collectionDate": "Fecha de recopilación de datos",
      "interviewType": "Tipo de entrevista",
      "structured": "Estructurada",
      "semiStructured": "Semiestructurada",
      "responderModel": "Modelo de respuesta",
      "supervisorModel": "Modelo de supervisión",
      "temperature": "Temperatura",
      "topP": "Top-p",
      "topK": "Top-k",
      "transcriptionEngine": "Motor de transcripción",
      "noSupervisor": "N/A (entrevista estructurada)",
      "notApplicable": "No aplicable",
      "copyCitation": "Copiar texto de cita",
      "copied": "¡Copiado!",
      "citationTemplate": "Las entrevistas se realizaron el {{date}} utilizando la plataforma Qualitati (qualitati.com). Las respuestas de IA fueron generadas por {{responderModel}} ({{responderProvider}}) con una temperatura de {{temperature}}, top-p de {{topP}} y top-k de {{topK}}. {{supervisorText}}La transcripción de voz utilizó {{transcriptionEngine}}.",
      "citationSupervisorText": "Una capa de supervisión ({{supervisorModel}}, temperatura {{supervisorTemp}}) guió el flujo de la entrevista. ",
 "interviewMode": "Modo de entrevista",
 "modeSingle": "Un solo modelo",
 "modeDual": "Doble modelo (con supervisor)",
 "companyPairing": "Combinación de empresas",
 "pairingSame": "Misma empresa",
 "pairingDifferent": "Empresas diferentes",
 "pairingNA": "N/A",
 "pairingUnknown": "Desconocido",
 "participantRating": "Calificación del participante",
    }
  },
  pt: {
    "title": "Registro de Conversa da Entrevista",
    "interviewee": "Entrevistado",
    "anonymous": "Anônimo",
    "interviewInfo": "Informações da Entrevista",
    "conversationContent": "Conteúdo da Conversa",
    "conversationStatistics": "Estatísticas da Conversa",
    "noConversationData": "Nenhum dado de conversa disponível",
    "backToAnalytics": "Voltar à Análise",
    "previousInterview": "Entrevista anterior",
    "nextInterview": "Próxima entrevista",
    "likeInterview": "Marcar como uma boa entrevista",
    "unlikeInterview": "Desmarcar como boa entrevista",
    "noPreviousInterview": "Sem entrevista anterior",
    "noNextInterview": "Sem próxima entrevista",
    "confirmComplete": "Tem certeza de que deseja marcar esta entrevista como concluída?",
    "confirmDelete": "Tem certeza de que deseja excluir esta entrevista? Esta ação não pode ser desfeita.",
    "actions": {
      "complete": "Marcar como concluído",
      "delete": "Excluir"
    },
    "labels": {
      "age": "Idade",
      "gender": "Gênero",
      "occupation": "Ocupação",
      "education": "Educação",
      "duration": "Duração",
      "status": "Status",
      "totalMessages": "Total de Mensagens",
      "userMessages": "Mensagens do Usuário",
      "aiMessages": "Mensagens de IA",
      "avgUserLength": "Comprimento Médio das Mensagens do Usuário",
      "avgAiLength": "Comprimento Médio das Mensagens de IA"
    },
    "roles": {
      "interviewee": "Entrevistado",
      "aiInterviewer": "Entrevistador de IA"
    },
    "customForm": {
      "title": "Informações do formulário personalizado",
      "field": "Campo",
      "na": "N/D"
    },
    "status": {
      "completed": "Concluído",
      "inProgress": "Em Andamento"
    },
    "minutes": "minutos",
    "qualityAssessment": {
      "title": "Avaliação de Qualidade e Conclusão Principal",
      "coreTakeaway": "Conclusão Principal",
      "excellent": "Excelente",
      "good": "Bom",
      "fair": "Regular",
      "poor": "Fraco",
      "tooShort": "Entrevista Muito Curta",
      "unknown": "Desconhecido"
    },
    "methodology": {
      "title": "Metodologia de coleta de dados",
      "subtitle": "Para fins de citação",
      "collectionDate": "Data de coleta de dados",
      "interviewType": "Tipo de entrevista",
      "structured": "Estruturada",
      "semiStructured": "Semi-estruturada",
      "responderModel": "Modelo de resposta",
      "supervisorModel": "Modelo de supervisão",
      "temperature": "Temperatura",
      "topP": "Top-p",
      "topK": "Top-k",
      "transcriptionEngine": "Motor de transcrição",
      "noSupervisor": "N/A (entrevista estruturada)",
      "notApplicable": "Não aplicável",
      "copyCitation": "Copiar texto de citação",
      "copied": "Copiado!",
      "citationTemplate": "As entrevistas foram realizadas em {{date}} usando a plataforma Qualitati (qualitati.com). As respostas de IA foram geradas por {{responderModel}} ({{responderProvider}}) com temperatura de {{temperature}}, top-p de {{topP}} e top-k de {{topK}}. {{supervisorText}}A transcrição de fala usou {{transcriptionEngine}}.",
      "citationSupervisorText": "Uma camada de supervisão ({{supervisorModel}}, temperatura {{supervisorTemp}}) guiou o fluxo da entrevista. ",
 "interviewMode": "Modo de entrevista",
 "modeSingle": "Modelo único",
 "modeDual": "Modelo duplo (com supervisor)",
 "companyPairing": "Combinação de empresas",
 "pairingSame": "Mesma empresa",
 "pairingDifferent": "Empresas diferentes",
 "pairingNA": "N/A",
 "pairingUnknown": "Desconhecido",
 "participantRating": "Avaliação do participante",
    }
  },
  ja: {
    "title": "インタビュー会話記録",
    "interviewee": "被インタビュー者",
    "anonymous": "匿名",
    "interviewInfo": "インタビュー情報",
    "conversationContent": "会話内容",
    "conversationStatistics": "会話統計",
    "noConversationData": "会話データがありません",
    "backToAnalytics": "分析に戻る",
    "previousInterview": "前のインタビュー",
    "nextInterview": "次のインタビュー",
    "likeInterview": "良いインタビューとしてマーク",
    "unlikeInterview": "良いインタビューのマークを解除",
    "noPreviousInterview": "前のインタビューはありません",
    "noNextInterview": "次のインタビューはありません",
    "confirmComplete": "このインタビューを完了としてマークしてもよろしいですか？",
    "confirmDelete": "このインタビューを削除してもよろしいですか？この操作は元に戻せません。",
    "actions": {
      "complete": "完了としてマーク",
      "delete": "削除"
    },
    "labels": {
      "age": "年齢",
      "gender": "性別",
      "occupation": "職業",
      "education": "学歴",
      "duration": "時間",
      "status": "ステータス",
      "totalMessages": "総メッセージ数",
      "userMessages": "ユーザーメッセージ",
      "aiMessages": "AIメッセージ",
      "avgUserLength": "平均ユーザーメッセージ長",
      "avgAiLength": "平均AIメッセージ長"
    },
    "roles": {
      "interviewee": "被インタビュー者",
      "aiInterviewer": "AIインタビュアー"
    },
    "customForm": {
      "title": "カスタムフォーム情報",
      "field": "フィールド",
      "na": "N/A"
    },
    "status": {
      "completed": "完了",
      "inProgress": "進行中"
    },
    "minutes": "分",
    "qualityAssessment": {
      "title": "品質評価と主要な洞察",
      "coreTakeaway": "主要な洞察",
      "excellent": "優秀",
      "good": "良好",
      "fair": "普通",
      "poor": "不良",
      "tooShort": "インタビューが短すぎる",
      "unknown": "不明"
    },
    "methodology": {
      "title": "データ収集方法論",
      "subtitle": "引用目的のために",
      "collectionDate": "データ収集日",
      "interviewType": "インタビュータイプ",
      "structured": "構造化",
      "semiStructured": "半構造化",
      "responderModel": "応答モデル",
      "supervisorModel": "監督モデル",
      "temperature": "温度",
      "topP": "Top-p",
      "topK": "Top-k",
      "transcriptionEngine": "転写エンジン",
      "noSupervisor": "該当なし（構造化インタビュー）",
      "notApplicable": "該当なし",
      "copyCitation": "引用テキストをコピー",
      "copied": "コピーしました！",
      "citationTemplate": "インタビューは{{date}}にQualitatiプラットフォーム（qualitati.com）を使用して実施されました。AI応答は{{responderModel}}（{{responderProvider}}）によって温度{{temperature}}、top-p {{topP}}、top-k {{topK}}で生成されました。{{supervisorText}}音声転写には{{transcriptionEngine}}を使用しました。",
      "citationSupervisorText": "監督層（{{supervisorModel}}、温度{{supervisorTemp}}）がインタビューの流れを導きました。",
 "interviewMode": "インタビューモード",
 "modeSingle": "シングルモデル",
 "modeDual": "デュアルモデル（スーパーバイザー付き）",
 "companyPairing": "企業の組み合わせ",
 "pairingSame": "同じ企業",
 "pairingDifferent": "異なる企業",
 "pairingNA": "該当なし",
 "pairingUnknown": "不明",
 "participantRating": "参加者の評価",
    }
  },
  ar: {
    "title": "سجل محادثة المقابلة",
    "interviewee": "المُقابَل",
    "anonymous": "مجهول",
    "interviewInfo": "معلومات المقابلة",
    "conversationContent": "محتوى المحادثة",
    "conversationStatistics": "إحصائيات المحادثة",
    "noConversationData": "لا توجد بيانات محادثة متاحة",
    "backToAnalytics": "العودة إلى التحليلات",
    "previousInterview": "المقابلة السابقة",
    "nextInterview": "المقابلة التالية",
    "likeInterview": "تمييز كمقابلة جيدة",
    "unlikeInterview": "إزالة تمييز المقابلة الجيدة",
    "noPreviousInterview": "لا توجد مقابلة سابقة",
    "noNextInterview": "لا توجد مقابلة تالية",
    "confirmComplete": "هل أنت متأكد من رغبتك في تحديد هذه المقابلة كمكتملة؟",
    "confirmDelete": "هل أنت متأكد من رغبتك في حذف هذه المقابلة؟ لا يمكن التراجع عن هذا الإجراء.",
    "actions": {
      "complete": "تحديد كمكتمل",
      "delete": "حذف"
    },
    "labels": {
      "age": "العمر",
      "gender": "الجنس",
      "occupation": "المهنة",
      "education": "التعليم",
      "duration": "المدة",
      "status": "الحالة",
      "totalMessages": "إجمالي الرسائل",
      "userMessages": "رسائل المستخدم",
      "aiMessages": "رسائل الذكاء الاصطناعي",
      "avgUserLength": "متوسط طول رسائل المستخدم",
      "avgAiLength": "متوسط طول رسائل الذكاء الاصطناعي"
    },
    "roles": {
      "interviewee": "المُقابَل",
      "aiInterviewer": "المُقابِل الذكاء الاصطناعي"
    },
    "customForm": {
      "title": "معلومات النموذج المخصص",
      "field": "الحقل",
      "na": "غير متاح"
    },
    "status": {
      "completed": "مكتملة",
      "inProgress": "قيد التنفيذ"
    },
    "minutes": "دقائق",
    "qualityAssessment": {
      "title": "تقييم الجودة والاستنتاج الرئيسي",
      "coreTakeaway": "الاستنتاج الرئيسي",
      "excellent": "ممتاز",
      "good": "جيد",
      "fair": "مقبول",
      "poor": "ضعيف",
      "tooShort": "المقابلة قصيرة جداً",
      "unknown": "غير معروف"
    },
    "methodology": {
      "title": "منهجية جمع البيانات",
      "subtitle": "لأغراض الاستشهاد",
      "collectionDate": "تاريخ جمع البيانات",
      "interviewType": "نوع المقابلة",
      "structured": "منظمة",
      "semiStructured": "شبه منظمة",
      "responderModel": "نموذج الاستجابة",
      "supervisorModel": "نموذج الإشراف",
      "temperature": "درجة الحرارة",
      "topP": "Top-p",
      "topK": "Top-k",
      "transcriptionEngine": "محرك النسخ",
      "noSupervisor": "لا ينطبق (مقابلة منظمة)",
      "notApplicable": "غير منطبق",
      "copyCitation": "نسخ نص الاستشهاد",
      "copied": "تم النسخ!",
      "citationTemplate": "أُجريت المقابلات في {{date}} باستخدام منصة Qualitati (qualitati.com). تم توليد ردود الذكاء الاصطناعي بواسطة {{responderModel}} ({{responderProvider}}) بدرجة حرارة {{temperature}} وtop-p بقيمة {{topP}} وtop-k بقيمة {{topK}}. {{supervisorText}}استخدم نسخ الكلام {{transcriptionEngine}}.",
      "citationSupervisorText": "طبقة إشراف ({{supervisorModel}}، درجة الحرارة {{supervisorTemp}}) وجّهت سير المقابلة. ",
 "interviewMode": "وضع المقابلة",
 "modeSingle": "نموذج واحد",
 "modeDual": "نموذج مزدوج (مع مشرف)",
 "companyPairing": "مزيج الشركات",
 "pairingSame": "نفس الشركة",
 "pairingDifferent": "شركات مختلفة",
 "pairingNA": "غير منطبق",
 "pairingUnknown": "غير معروف",
 "participantRating": "تقييم المشارك",
    }
  }
};
